// extracted by mini-css-extract-plugin
export default {"root":"d0jc3","cols":"uqfWo","submit":"S_jwt"};